<template>
  <div style="background: #f2f2f2;padding-bottom: 20px">
    <!-- 面包屑 -->
    <div class="position container yu_fc particles_box">
      <router-link to="/">首页</router-link><i></i>
      <router-link :to="{ path: '/helpCenter', query: { key: 'helpCenter' } }">帮助中心</router-link>
    </div>
    <div class="container yu_fc particles_box" style="background: #f2f2f2;">
      <div class="left">
        <!-- @click="categoryActive = null" -->
        <h3>常见问题分类</h3>
        <el-menu text-color="#333" active-text-color="#333" @open="handleSubMenuOpen">
          <el-submenu v-for="(item, index) in category" :key="index" :index="item.productCategoryId + ''">
            <template slot="title">
              <span>{{item.productCategoryName}}</span>
            </template>
            <el-menu-item-group v-for="(value, indeo) in item.children" :key="indeo">
              <el-menu-item :index="value.id" @click="handleMenuItemOpen">{{value.name}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <div class="right">
        <template v-for="item in category">
          <template v-for="itec in item.children">
            <template v-if="categoryActive == null">
              <el-collapse>
                <el-collapse-item v-for="(ited,indeo) in itec.children" :key="ited.name+indeo" :title="ited.name" :name="ited.name+indeo">
                  <div class="show_box">{{ited.name}}{{ited.name}}{{ited.name}}
                    <p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-if="itec.id == categoryActive">
              <el-collapse>
                <el-collapse-item v-for="(ited,indeo) in itec.children" :key="ited.name+indeo" :title="ited.name" :name="ited.name+indeo">
                  <div class="show_box">{{ited.name}}{{ited.name}}{{ited.name}}
                    <p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p><p>{{ited.name}}</p>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </template>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { productCategoryOne, productCategoryTwoThree } from "@/api/baseData";
export default {
  name: "helpCenter",
  data() {
    return {
      category: [],
      categoryOne: [], // 一级分类
      categoryTwo: [], // 一级分类下的数据
      categoryActive: null
    };
  },
  created() {
    this.categData()
  },
  methods: {
    async categData() {
      let _this = this
      const res = await productCategoryOne();
      console.log(res);
      if (res.code == 200) {
        this.category = res.data;
      }
    },
    handleSubMenuOpen(key) {
      console.log(key)
    },
    handleMenuItemOpen(key) {
      console.log(key)
      this.categoryActive = null
      this.categoryActive = key.index
    },
    showIndex(show){
      console.log(show)
    }
  }
};
</script>

<style scoped>
.left{
  float: left;
  width: 200px;
}
.left h3{
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  background:rgba(32,122,191,1);
}
.el-menu {
  float: left;
  width: 100%;
  overflow: hidden;
}
.el-menu >>> .el-submenu__title {
  height: 48px;
  line-height: 48px;
  text-indent: 10px;
  border-bottom: solid 1px rgba(218,218,218,1);
}
.el-menu >>> .el-menu-item {
  height: 48px;
  line-height: 48px;
  background:rgba(242,242,242,1);
  border-bottom: solid 1px rgba(218,218,218,1);
}
.el-menu >>> .el-icon-arrow-down{
  font-size: 16px;
  margin-top: -8px;
  text-indent: 0;
}
.el-menu >>> .el-menu-item.is-active {
  color:rgba(32,122,191,1) !important;
}
.el-menu >>> .el-submenu__title:hover {
  background: rgba(230, 230, 230, 1);
}
.el-menu >>> .el-menu-item:hover {
  background: rgba(230, 230, 230, 1);
}
.el-menu >>> .el-menu-item-group__title {
  height: 0;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
.right {
  float: left;
  width: 960px;
  margin-left: 20px;
}
.right .el-collapse-item{
  float: left;
  width: 100%;
  padding-bottom: 20px;
}
.right >>> .el-collapse{
  border: none
}
.right >>> .el-collapse-item__header{
  float: left;
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color:rgba(32,122,191,1);
  padding: 0 20px;
  background:rgba(244,250,255,1);
}
.right >>> .el-icon-arrow-right{
  display: none
}
.right >>> .el-collapse-item__wrap{
  float: left;
  width: 100%;
  background:rgba(255,255,255,1);
  box-shadow:0px 3px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius:0px 0px 4px 4px;
}
.right .show_box{
  line-height: 1.7;
  padding: 16px 20px 0;
}
.right .show_box *{
  line-height: 1.7;
}
</style>